export default {
    apiUrl: `https://${window.location.hostname}/telepase/`,
    // apiUrl: 'http://190.96.113.62/telepase/', //PUBLICA 8083
    // apiUrl: 'http://localhost:8081/telepase/', //LOCAL YO
};

const siteConfig = {
    siteName: 'CAMINOS DE LAS SIERRAS',
    siteIcon: 'ion-model-s',
    footerText: 'Caminos de las Sierras ©2019',
};
const themeConfig = {
    topbar: 'themedefault',
    sidebar: 'themedefault',
    layout: 'themedefault',
    theme: 'themedefault',
};

const googleConfig = {
    apiKey: 'AIzaSyCa2gjQaJ_hPgO4XWYQuHGplaRJT-6LVm4'
};
//'AIzaSyCa2gjQaJ_hPgO4XWYQuHGplaRJT-6LVm4' API HI
//'AIzaSyDlpxMjd6xncMRswYXLBt2O5qPJ7yBvAzQ' API TELEPASE
const language = 'spanish';


export {siteConfig, language, themeConfig, googleConfig};
